meedy.factory('meedy.specializationService', ['$q', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function($q, baseService, objectHelper, config) {

        function SpecializationService() {

            this.physicianSpecializations = function() {

                return baseService.get(config.API_URL + '/specializations/physicianSpecializations').then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, OfferMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getOffersForSpecializationId = function(idSpecialization) {

                return baseService.get(config.API_URL + '/specializations/getOffersForSpecializationId/' + idSpecialization).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, OfferMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getDefaultOffersForSpecializationId = function(idSpecialization) {

                return baseService.get(config.API_URL + '/specializations/getDefaultOffersForSpecializationId/' + idSpecialization).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, OfferMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new SpecializationService();
    }
]);
